module.exports = __webpack_public_path__ + "media/images/flags/pe-83cbe7a2e738d12672430962936a45ab.svg";